export enum OrbitUnpauseStep {
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  UNPAUSED,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  DEADLINE_EXCEEDED,
  REJECTED_BY_THE_USER,
}
